import React, {useEffect, useState} from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import styles from "./styles/success.module.css";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { useLocation, useNavigate } from "react-router-dom";

const PaymentSuccess = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { stripePromise } = props;
    const isOnboarding = localStorage.getItem("isOnboarding");

    useEffect(() => {
        const currentStep = parseInt(localStorage.getItem("currentCompleted"));

        if (location.pathname.includes("/payment-success")) {
            if (currentStep === 3) {
                localStorage.removeItem("currentCompleted");
                // localStorage.removeItem("LPCurrentUserId");
                localStorage.removeItem("LPCurrentUserEmail");
                localStorage.removeItem("LPCurrentUserName");
                localStorage.removeItem("LPCurrentProvideruid");
                localStorage.removeItem("LPCurrentClinicTitle");
                localStorage.removeItem("LPCurrentClinicId");
                localStorage.removeItem("selectedPlan");
                localStorage.removeItem("isOnboarding");
                if(isOnboarding === "yes"){
                    localStorage.removeItem("LPCurrentUserId");
                    navigate('/signup');
                }else{
                    navigate('/practitioner/listing');
                }
            } else if (currentStep === 2) {
                localStorage.setItem("currentCompleted", 3);
            } else {
                if(isOnboarding === "yes"){
                    navigate('/signup');
                }else{
                    navigate('/practitioner/listing');
                }
            }
        }
    }, [location, navigate]);

    useEffect(() => {
        if (!stripePromise) return;
    
        stripePromise.then(async (stripe) => {
            const url = new URL(window.location.href);
            const clientSecret = url.searchParams.get('payment_intent_client_secret');
    
            if (!clientSecret) {
                console.warn("Missing payment_intent_client_secret in URL");
                return;
            }
    
            const { error, paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
            
            if (error) {
                console.error("Stripe error:", error.message);
            } else {
                console.log("Payment Intent:", paymentIntent);
            }
        });
    }, [stripePromise]);
    

    return (
        <Container className={styles.container}>
            <Box className={styles.mainContent} sx={isOnboarding === "yes" ? {} : {height: '100vh', background: '#fff', justifyContent: 'center'}}>
                <Box className={styles.checkmark}><DoneOutlinedIcon className={styles.checkIcon} /></Box>
                <Typography variant="gotham5XL" className={styles.title}>
                    Payment successful
                </Typography>
                <Typography variant="gothamMediumLarge" className={styles.description}>
                    Thank you for completing your payment. <br />
                    Your clinic listing is almost live on Local Physio.
                </Typography>

                {/* What Happens Next */}
                {
                    isOnboarding === "yes"
                    ?(
                        <Box className={styles.stepsSection}>
                            <Typography variant="gothamXL" className={styles.stepsTitle}>
                                What happens next
                            </Typography>
                            <Box className={styles.stepsContainer}>
                                <Box className={styles.stepCard}>
                                    <AccessTimeIcon />
                                    <Typography variant="gothamMedium" className={styles.stepTitle}>
                                        Review in progress
                                    </Typography>
                                    <Typography variant="gothamMedium" className={styles.stepText}>
                                        Our team will review your clinic details within 2 business days.
                                        We will contact you with any queries.
                                    </Typography>
                                </Box>
                                <Box className={styles.stepCard}>
                                    <CampaignOutlinedIcon />
                                    <Typography variant="gothamMedium" className={styles.stepTitle}>
                                        Go live
                                    </Typography>
                                    <Typography variant="gothamMedium" className={styles.stepText}>
                                        You will be notified by email as soon as your clinic profile is listed.
                                    </Typography>
                                </Box>
                                <Box className={styles.stepCard}>
                                    <PersonAddAltOutlinedIcon />
                                    <Typography variant="gothamMedium" className={styles.stepTitle}>
                                        Manage your account
                                    </Typography>
                                    <Typography variant="gothamMedium" className={styles.stepText}>
                                        Once live, you can add practitioners and update details.
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    ):(
                        <Box className={styles.stepsSection}>
                            <Button 
                                variant="contained" className={styles.addButton} 
                                onClick={() => {
                                    navigate('/practitioner/listing');
                                }}
                            >
                                Back To Listing
                            </Button>
                        </Box>
                    )
                }
            </Box>

            {/* Additional Clinics */}
            {
                isOnboarding === "yes" && (
                    <Box className={styles.footer}>
                        <Typography variant="gotham2XL" className={styles.footerText}>
                            Have more clinics to add?
                        </Typography>
                        <Typography variant="gothamMediumLarge">
                            Email us at{" "}
                            <a href="mailto:info@local-physio.co.uk" className={styles.emailLink}>
                                info@local-physio.co.uk
                            </a>{" "}
                            for a multi-clinic discount.
                        </Typography>
                    </Box>
                )
            }
        </Container>
    );
};

export default PaymentSuccess;
